import React, { Component } from "react";
import {  Modal } from "react-bootstrap";
import HeadOfficeList from "containers/headoffice/HeadOfficeList";



export default class HeadOfficeModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
         
            isLoading: true,
            
        };

        
     
       
    }
    

    async componentDidMount() {
        console.log("In HeadOfficeModal componentDidMount");
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if (!this.props.show) {
            return null;
        }

           
    }

    componentWillUnmount() {
        this.setState({ entities: [] });
    }


    

    renderHeadOffices() {
        return (
            
            <Modal
                show={this.props.show}
                onHide={this.props.toggleHeadOfficeSearchDialog}
                dialogClassName="modal-90w"
                >
                <Modal.Header closeButton>
                    <Modal.Title>Head Offices with Matching Name</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ 'overflowX': 'scroll' }}>
           
               
                

              

                        <HeadOfficeList
                        filter={this.props.filter}
                        isAuthenticated={this.props.isAuthenticated}
                        isLoading={this.state.isLoading}
                        controlType="table2"
                        saveForm={this.props.saveForm}
                        user={this.props.user}
                        data={this.props.data}
                        updateTableState={this.props.updateTableState}
                        saveRecord={this.props.saveRecord}
                        deleteRecord={this.props.deleteRecord}
                        validateRelatedRecord={this.props.validateRelatedRecord}
                        leaseid={this.props.leaseid}
                        toggleHeadOfficeSearchDialog={this.props.toggleHeadOfficeSearchDialog}
                        />

                  
          
                    </Modal.Body>
            </Modal>
        );
    }
    
    


    render() {
        return (

            <div className="HeadOfficeEdit">
                {this.props.isAuthenticated ? this.renderHeadOffices() : console.log("error)")}
            </div>
        );
    }
}
